/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
// import config from "../config/completeDist.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { COMPLETE_DIST } from "../graphql";
import { VApplication } from "../../../application";

import { AppNavigatorService } from "../../appNavigatorService";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import moment from "moment";
import toast from "react-hot-toast";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICompleteDistMethods extends IPluginMethodMap {
  completeDist(args: any): Promise<any>;
}

export class CompleteDistService implements IAgentPlugin {
  readonly methods: ICompleteDistMethods;

  constructor() {
    this.methods = {
      completeDist: this.completeDist.bind(this),
    };
  }

  async completeDist(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    //return {...(config)}
    const distCenterData = storageService.get("distCenterData", "local");
    console.log(`bla distCenterData in payment service`, distCenterData);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: COMPLETE_DIST,
          variables: {
            counterId: distCenterData?.paymentCounter,
            tokenKey: args?.tokenKey,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          console.log(`Notification data`, res.data);
          // toast.success("Notification sent");
          return {
            ...res?.data?.notifyCollector,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    // return {...(config || {})}
  }
}
